import ProductsContainer from '../containers/ProductsContainer'

export default function Products () {
  return (
    <section className='section'>
      <ProductsContainer />
    </section>
  )
}
